import styled from "styled-components";

export const TitleLogin = styled.span`
    font-family: var(--font-primary);
    font-style: normal;
    font-weight: 300;
    font-size: 40px;
    color: var(--color-brand);
    &.bold {
        font-weight: 700;
    }
`
export const SubtitleLogin = styled.span`
    font-family: var(--font-primary);
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    color: var(--color-brand);
`
